<!-- bottom = height of toast + margin-->
<div
  class="toast"
  [ngStyle]="{
    bottom: position * 64 + 24 + 'px',
    'margin-bottom': '16px'
  }"
>
  {{ message }}
</div>
